import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import { translate } from "react-i18next";
import { Container } from "reactstrap";
import {
  Navbar,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Valert, Vmodal } from "../components";
import {
  getLoggedInUser,
  isLoggedIn,
  logout,
} from "../services/AuthenticationService";
import HomePage from "./HomePage";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import SignUp from "./SignUp";
import Dashboard from "./Dashboard";
import MainView from "./MainView";
import Symptom from "./Symptom";
import EditSymptom from "./EditSymptom";
import Graph from "./Graph";
import Profile from "./Profile";
import ProfileUpdate from "./ProfileUpdate";
import ChangePassword from "./ChangePassword";
import SubUserCreate from "./SubUserCreate";
import ForgotPasswordReset from "./ForgotPasswordReset";
import RecipeManagement from "./RecipeManagement";
import Recipe from "./Recipe";
import MealPlanSummary from "./MealPlanSummary";
import MealPlanner from "./MealPlanner";
import Forum from "./Forum";
import ForumMe from "./ForumMe";
import ForumSingle from "./ForumSingle";
import ForumArchive from "./ForumArchive";
import Inbox from "./Inbox";
import Product from "./Product";
import BodyMap from "./BodyMap";
import Contribute from "./Contribute";
import DailyInputSummary from "./DailyInputSummary";
import InfoAndSupport from "./InfoAndSupport";
import MessagingInbox from "./Message";

import {
  isLoadedFromMobile,
  getCurrentOrientation,
} from "../services/MobileService";
import { Orientations } from "./PageConstants";

import "./styles/mainpage.css";
import "./styles/appShellModern.css";
import { getInboxNum, getNotifyNum } from "../services/UserService";
import { IS_UNSAVED, USER_LANG } from "../actions/constant";
import i18next from "i18next";
import i18n from "../i18n";

function clearUnsavedFlags() {
  localStorage.removeItem("unsavedAlertData");
  localStorage.removeItem("logoutWithoutSaveRegimen");
  localStorage.removeItem("logoutWithoutSaveRecipe");
  sessionStorage.removeItem("previousPageIsDirty");
  sessionStorage.removeItem("messageFilter");
  localStorage.removeItem("unContributed");
  localStorage.removeItem("contDefault");

  localStorage.removeItem("recipeCat");
  localStorage.removeItem("bodyreturn");
  localStorage.removeItem("Dashboard_User_Selected");
}
class MainPage extends Component {
  constructor(props) {
    super(props);
    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.pModal = this.pModal.bind(this);
    this.closeNavbar = this.closeNavbar.bind(this);
    this.doLogout = this.doLogout.bind(this);
    this.state = {
      collapsed: true,
      saveDataValert: false,
      unsavedAlertTitle: null,
      unsavedAlertText: null,
      unsavedAlertScreen: null,
      pModalStatus: false,
      notifyNum: 0,
      inboxNum: 0,
      user: false,
      pageTitle: "",
      unsavedAlertPositiveTitle: "",
    };
  }

  async componentDidMount() {
    // 1) Pick up any stored language and apply it immediately
    const storedLang =
      sessionStorage.getItem("i18nextLng") || localStorage.getItem("i18nextLng");
    if (storedLang && i18n.language !== storedLang) {
      try {
        await i18n.changeLanguage(storedLang);   // <-- use changeLanguage, not i18n.locale
        localStorage.setItem("i18nextLng", storedLang);
      } catch (e) {}
    }

    // NEW: react immediately to any later language changes (e.g., from HomePage)
    this._onLangChange = () => this.pageTitle(window.location.pathname);
    i18n.on("languageChanged", this._onLangChange);


    // 2) Now compute the page title in the *correct* language
    this.pageTitle(window.location.pathname);

    window.addEventListener("recipe-title-updated", (e) => {
      this.setState({ pageTitle: e.detail || localStorage.getItem("recipePageTitle") });
    });

    if (isLoggedIn()) {
      let num = await getNotifyNum(); //localStorage.getItem("notifyNum");
      this.setState({ notifyNum: num });
      let inboxNum = await getInboxNum();
      this.setState({
        inboxNum: inboxNum,
        user: true,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const prevLang = prevProps.i18n && prevProps.i18n.language;
    const currLang = this.props.i18n && this.props.i18n.language;
    const prevPath = prevProps.location.pathname;
    const currPath = this.props.location.pathname;

    if (prevLang !== currLang || prevPath !== currPath) {
      this.pageTitle(currPath);
    }
  }

  componentWillUnmount() {
    if (this._onLangChange) {
      i18n.off("languageChanged", this._onLangChange);
    }
  }

  toggleNavbar() {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }
  pModal() {
    this.setState({ pModalStatus: true });
  }
  closeNavbar() {
    if (!this.state.collapsed) {
      this.setState({
        collapsed: true,
      });
    }
  }

  handleLogout() {
    clearUnsavedFlags();

    setTimeout(() => {
      logout();
      this.setState({
        user: false,
      });
      window.location.href = "/";
    }, 50);
  }
  doLogout() {
    const logoutWithoutSaveRegimen = localStorage.getItem(
      "logoutWithoutSaveRegimen"
    );
    const logoutWithoutSaveRecipe = localStorage.getItem(
      "logoutWithoutSaveRecipe"
    );
    let isFromContPage = JSON.parse(localStorage.getItem("unsavedAlertData"));
    isFromContPage =
      isFromContPage && isFromContPage.redirectedFrom
        ? isFromContPage.redirectedFrom
        : isFromContPage && isFromContPage.page === "bodyMap"
          ? isFromContPage
          : null;

    if (
      logoutWithoutSaveRegimen &&
      logoutWithoutSaveRegimen == "Yes" &&
      !isFromContPage
    ) {
      this.logoutWithoutSaveRegimen.changeStatus();
    } else if (
      logoutWithoutSaveRecipe &&
      logoutWithoutSaveRecipe == "Yes" &&
      !isFromContPage
    ) {
      this.logoutWithoutSaveRecipe.changeStatus();
    } else {
      if (IS_UNSAVED() == "yes") {
        let unsavedAlertData = JSON.parse(
          localStorage.getItem("unsavedAlertData")
        );

        this.p_urlName = "logout";

        if (
          unsavedAlertData &&
          unsavedAlertData.page &&
          unsavedAlertData.page !== "inbox" &&
          unsavedAlertData.screen !== "account" &&
          unsavedAlertData.page !== "bodyMap" &&
          unsavedAlertData.page !== "contribute" &&
          unsavedAlertData.page !== "meal_planner" &&
          unsavedAlertData.page !== "profile" &&
          unsavedAlertData.page !== "recipe_management"
        ) {
          this.setState({
            saveDataValert: true,
            unsavedAlertTitle: this.props.t(
              "general.UNSAVED_DATA_LOGOUT_TITLE"
            ),
            unsavedAlertText:
              unsavedAlertData.page == "input"
                ? this.props.t("general.UNSAVED_DATA_LOGOUT_TEXT")
                : unsavedAlertData.page == "edit" &&
                this.props.t("general.UNSAVED_EDIT_PAGE_DATA_LOGOUT_TEXT"),
            unsavedAlertPositiveTitle: unsavedAlertData
              ? unsavedAlertData.positiveBtnText
              : null,
          });
        } else if (
          unsavedAlertData &&
          unsavedAlertData.page &&
          unsavedAlertData.page == "profile"
        ) {
          this.setState({
            saveDataValert: true,
            unsavedAlertTitle: unsavedAlertData.title,
            unsavedAlertText: unsavedAlertData.isNew
              ? this.props.t("profile.UNSAVED_NEW_SUBUSER_TEXT_2")
              : this.props.t("profile.UNSAVED__CURRENT_PROFILE_CHANGE_TEXT"),
          });
        } else if (
          unsavedAlertData &&
          unsavedAlertData.page &&
          unsavedAlertData.page == "contribute"
        ) {
          this.setState({
            saveDataValert: true,
            unsavedAlertTitle: unsavedAlertData.redirectedFrom
              ? this.props.t("bodyMap.UNSAVED_BM_DATA_TITLE", {
                pageName: unsavedAlertData.redirectedFrom,
              })
              : unsavedAlertData.title,
            unsavedAlertText: unsavedAlertData.redirectedFrom
              ? this.props.t("contribute.UNSAVED_CON_DATA_TEXT", {
                pageName: unsavedAlertData.redirectedFrom,
              })
              : this.props.t("contribute.UNSAVED_CONT_DATA_LOGOUT_TEXT"),
            unsavedAlertPositiveTitle: unsavedAlertData.redirectedFrom
              ? this.props.t("bodyMap.SWITCH")
              : null,
          });
        } else if (
          unsavedAlertData &&
          unsavedAlertData.page &&
          unsavedAlertData.page == "inbox"
        ) {
          this.setState({
            saveDataValert: true,
            unsavedAlertTitle: unsavedAlertData.title,
            unsavedAlertText: this.props.t("general.UNSAVED_DRAFT_LOGOUT_TEXT"),
            unsavedAlertScreen: unsavedAlertData
              ? unsavedAlertData.screen
                ? unsavedAlertData.screen
                : null
              : null,
          });
        } else if (unsavedAlertData && unsavedAlertData.page === "bodyMap") {
          this.setState({
            saveDataValert: true,
            unsavedAlertTitle: unsavedAlertData ? unsavedAlertData.title : null,
            unsavedAlertText: unsavedAlertData ? unsavedAlertData.text : null,
            unsavedAlertPositiveTitle: unsavedAlertData
              ? unsavedAlertData.positiveBtnText
              : null,
          });
        } else if (
          unsavedAlertData &&
          unsavedAlertData.page === "meal_planner" || unsavedAlertData.page === "mealplanner"
        ) {
          this.setState({
            saveDataValert: true,
            unsavedAlertTitle: unsavedAlertData ? unsavedAlertData.title : null,
            unsavedAlertText: unsavedAlertData
              ? unsavedAlertData.logout_text
              : null,
            unsavedAlertPositiveTtitle: unsavedAlertData
              ? unsavedAlertData.positiveBtnText
              : null,
          });
        } else if (
          unsavedAlertData &&
          unsavedAlertData.page == "recipe_management"
        ) {
          this.setState({
            saveDataValert: true,
            // use the logout-specific title
            unsavedAlertTitle: this.props.t("recipe_management.INCOMPLETE_ACTION_ON_SELECTED_ITEM_TITLE"),
            // prefer a page-specific logout text if you add one in i18n;
            // otherwise fall back to the general logout text.
            unsavedAlertText:
              this.props.t("recipe_management.INCOMPLETE_ACTION_ON_SELECTED_ITEM_TEXT"),
            unsavedAlertPositiveTitle: unsavedAlertData
              ? unsavedAlertData.positiveBtnText
              : null,
          });
        } else if (unsavedAlertData && unsavedAlertData.screen !== "account") {
          this.setState({
            saveDataValert: true,
            unsavedAlertTitle: unsavedAlertData ? unsavedAlertData.title : null,
            unsavedAlertText: unsavedAlertData
              ? unsavedAlertData.logout_text
                ? unsavedAlertData.logout_text
                : unsavedAlertData.text
              : null,
            unsavedAlertPositiveTtitle: unsavedAlertData
              ? unsavedAlertData.positiveBtnText
              : null,
          });
        }

        if (
          (unsavedAlertData && unsavedAlertData.screen === "account") ||
          !unsavedAlertData
        ) {
          logout();
          window.location.href = "/";
          this.setState({
            user: false,
          });
        }
      } else {
        this.handleLogout();
      }
    }
  }

  gotoPath(p_urlName) {
    if (IS_UNSAVED() == "yes") {
      let unsavedAlertData = JSON.parse(
        localStorage.getItem("unsavedAlertData")
      );
      this.p_urlName = p_urlName;
      if (unsavedAlertData && unsavedAlertData.redirectedFrom) {
        this.setState({
          saveDataValert: true,
          unsavedAlertTitle: unsavedAlertData.redirectedFrom
            ? this.props.t("bodyMap.UNSAVED_BM_DATA_TITLE", {
              pageName: unsavedAlertData.redirectedFrom,
            })
            : unsavedAlertData.title,
          unsavedAlertText: unsavedAlertData.redirectedFrom
            ? this.props.t("contribute.UNSAVED_CON_DATA_TEXT", {
              pageName: unsavedAlertData.redirectedFrom,
            })
            : this.props.t("contribute.UNSAVED_CONT_DATA_LOGOUT_TEXT"),
          unsavedAlertPositiveTitle: unsavedAlertData.redirectedFrom
            ? this.props.t("bodyMap.SWITCH")
            : null,
        });
      } else {
        this.setState({
          saveDataValert: true,
          unsavedAlertTitle: unsavedAlertData ? unsavedAlertData.title : null,
          unsavedAlertText: unsavedAlertData ? unsavedAlertData.text : null,
          unsavedAlertScreen: unsavedAlertData
            ? unsavedAlertData.screen
              ? unsavedAlertData.screen
              : null
            : null,
          unsavedAlertPositiveTitle:
            unsavedAlertData && unsavedAlertData.positiveBtnText
              ? unsavedAlertData.positiveBtnText
              : this.props.t("general.POSITIVE_PROMPT_TEXT"),
        });
      }
    } else {
      clearUnsavedFlags();
      setTimeout(() => {
        window.location.href = p_urlName;
      }, 50);
    }
  }
  pageTitle(pathname) {
    const tNow = i18n.t.bind(i18n);
    pathname = pathname.replace(/\/$/, "");
    var _pageHeader;
    // check if user is logegedin
    if (
      (!getLoggedInUser() || getLoggedInUser() == undefined) &&
      pathname !== "" &&
      pathname !== "/" &&
      pathname !== "/signup" &&
      pathname !== "/resetpassword" &&
      pathname !== "/forgotpassword" &&
      !pathname.includes("/forgotpasswordreset")
    ) {
      logout();
      this.props.history.push("/");
    }
    // end check
    if (!isLoggedIn()) {
      _pageHeader = tNow("home.WELCOME");
      if (pathname === "/" || pathname === "") {
        _pageHeader = tNow("home.WELCOME");
      } else if (pathname === "/signup") {
        _pageHeader = tNow("signUp.TITLE");
      } else if (pathname === "/forgotpassword") {
        _pageHeader = tNow("forgot.PAGE_TITLE");
      } else if (pathname.includes("/forgotpasswordreset")) {
        _pageHeader = tNow("forgot.RESET_PASSWORD_TITLE");
      }
    } else {
      if (pathname === "/recipe") {
        var recipePageTitle = localStorage.getItem("recipePageTitle");
        if (recipePageTitle) {
          _pageHeader = recipePageTitle;
        } else {
          _pageHeader = tNow("recipe.CREATE_REGIMEN_PAGE_TITLE");
        }
      } else if (pathname.includes("mealplanner")) {
        _pageHeader = tNow("meal_planner.PAGE_TITLE");
      } else if (pathname.includes("/mealplansummary")) {
        _pageHeader = tNow("meal_plan_summary.PAGE_TITLE");
      } else if (pathname.includes("/post/")) {
        _pageHeader = tNow("forum.SELECTED_POST_TITLE");
      } else if (pathname === "/forum") {
        _pageHeader = tNow("forum.PAGE_TITLE");
      } else if (pathname === "/forum/me") {
        _pageHeader = tNow("forum.PAGE_TITLE_ME");
      } else if (pathname.includes("/forum/archive")) {
        _pageHeader = tNow("forum.PAGE_TITLE_ARCHIVED");
      } else if (pathname.includes("/forum/")) {
        _pageHeader = tNow("forum.PAGE_TITLE_USER");
      } else if (pathname === "/dashboard") {
        _pageHeader = tNow("menu.VIEW_SUMMARY");
      } else if (pathname === "/profile") {
        _pageHeader = tNow("general.PROFILE_TITLE");
      } else if (pathname === "/changepassword") {
        _pageHeader = "User Profile";
      } else if (pathname === "/subusercreate") {
        _pageHeader = "Add Sub User";
      } else if (pathname === "/recipemanagement") {
        _pageHeader = tNow("recipe_management.MANAGE_AND_EDIT_TITLE");
      } else if (pathname === "/symptom") {
        _pageHeader = tNow("symptoms.PAGE_TITLE");
      } else if (pathname === "/editsymptoms") {
        _pageHeader = tNow("editsymptoms.PAGE_TITLE");
      } else if (pathname === "/graph") {
        _pageHeader = tNow("graph.PAGE_TITLE");
      } else if (pathname === "/contribute") {
        _pageHeader = tNow("menu.CONTRIBUTE_DATA");
      } else if (pathname === "/bodymap") {
        _pageHeader = tNow("menu.BODY_MAP");
      } else if (pathname === "/" || pathname === "") {
        _pageHeader = tNow("home.WELCOME");
      } else if (pathname === "/signup") {
        _pageHeader = tNow("signUp.TITLE");
      } else if (pathname === "/main") {
        _pageHeader = tNow("stocks.ORGANIZE_SYMPTOMS_TEXT");
      } else if (pathname === "/forgotpassword") {
        _pageHeader = tNow("forgot.PAGE_TITLE");
      } else if (pathname.includes("/forgotpasswordreset")) {
        _pageHeader = tNow("forgot.RESET_PASSWORD_TITLE");
      } else if (pathname === "/inbox") {
        _pageHeader = tNow("inbox.SHARED_BOX_TITLE");
      } else if (pathname === "/dailyinputsummary") {
        _pageHeader = tNow("dailySummary.PAGE_TITLE");
      } else if (pathname === "/infoandsupport") {
        _pageHeader = tNow("support.PAGE_TITLE");
      } else if (pathname === "/message") {
        _pageHeader = tNow("menu.INBOX");
      }
    }
    this.setState({ pageTitle: _pageHeader });
  }

  render() {
    const pathname = this.props.location.pathname;
    const t = this.props.t;
    var _navbarTitle, _homeLinkSize;
    if (
      isLoadedFromMobile() ||
      getCurrentOrientation() === Orientations.PORTRAIT
    ) {
      _navbarTitle = "navbartitle-mobile";
      _homeLinkSize = "1rem";
    } else {
      _navbarTitle = "navbartitle";
      _homeLinkSize = "1.25rem";
    }
    return (
      <Container fluid={true} className="container-fluid">
        <Valert
          zIndex={200000}
          display={!this.state.unsavedAlertScreen && this.state.saveDataValert}
          //onRef={ref => (this.removeItemValert = ref)}
          title={
            this.state.unsavedAlertTitle
              ? this.state.unsavedAlertTitle
              : t("editsymptoms.UNSAVED_PAGE_TITLE")
          }
          question={
            this.state.unsavedAlertText
              ? this.state.unsavedAlertText
              : t("general.UNSAVED_LEAVE_PAGE_TEXT")
          }
          positiveAction={() => {
            IS_UNSAVED("no");
            clearUnsavedFlags();

            if (this.p_urlName == "logout") {
              logout();
              window.location.href = "/";
              this.setState({
                user: false,
              });
            } else {
              this.gotoPath(this.p_urlName);
            }
          }}
          negativeAction={() => {
            setTimeout(() => {
              this.setState({ saveDataValert: false });
            }, 200);
          }}
          positiveText={
            this.state.unsavedAlertPositiveTitle
              ? this.state.unsavedAlertPositiveTitle
              : t("general.POSITIVE_PROMPT_TEXT")
          }
          negativeText={t("general.CANCEL")}
        />
        <Valert
          zIndex={200000}
          display={false}
          onRef={(ref) => (this.logoutWithoutSaveRegimen = ref)}
          title={t("recipe.UNSAVED_REGIMEN_LEAVE_PAGE_TITLE")}
          question={t("recipe.UNSAVED_REGIMEN_LEAVE_PAGE_TEXT")}
          positiveAction={() => {
            this.handleLogout();
          }}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
        />

        <Valert
          zIndex={200000}
          display={false}
          onRef={(ref) => (this.logoutWithoutSaveRecipe = ref)}
          title={t("recipe.UNSAVED_RECIPE_LEAVE_PAGE_TITLE")}
          question={t("recipe.UNSAVED_RECIPE_LEAVE_PAGE_TEXT")}
          positiveAction={() => {
            this.handleLogout();
          }}
          positiveText={t("general.POSITIVE_PROMPT_TEXT")}
          negativeText={t("general.CANCEL")}
        />

        <Vmodal
          displayStatus={
            this.state.unsavedAlertScreen && this.state.saveDataValert
          }
          data={
            <div>
              <h4>{t("support.SAVED_DRAFT_DATA_TITLE")}</h4>
              <p>{t("support.SAVED_DRAFT_DATA_TEXT")}</p>
            </div>
          }
          closeFunc={() => {
            IS_UNSAVED("no");
            clearUnsavedFlags();
            this.setState({ saveDataValert: false });
            localStorage.removeItem("unsavedAlertData");
            localStorage.removeItem("logoutWithoutSaveRegimen");
            localStorage.removeItem("logoutWithoutSaveRecipe");
            if (this.p_urlName === "logout") {
              this.doLogout();
            } else {
              this.gotoPath(this.p_urlName);
            }
          }}
          timedClose={2000}
        />
        <Navbar color="primary" dark fixed="top">
          <a
            href="https://12u12.com"
            target="_blank"
            style={{ fontSize: _homeLinkSize }}
            className="navbar-brand"
          >
            <img className="mainLogo" src={require("../images/logo.png")} />
          </a>
          <div className={_navbarTitle}>
            <b>{this.state.pageTitle}</b>
          </div>
          {
            pathname !== "/" &&
            !pathname.includes("/signup") &&
            pathname != "/resetpassword" &&
            !pathname.includes("/forgotpassword") &&
            !pathname.includes("/forgotpasswordreset") &&
            pathname != "/contributeCom" && (
              <Dropdown
                direction="left"
                isOpen={!this.state.collapsed}
                toggle={this.toggleNavbar}
              >
                <DropdownToggle color="primary">
                  <i className="fa fa-bars" />
                </DropdownToggle>
                <DropdownMenu
                  modifiers={{
                    setMaxHeight: {
                      enabled: true,
                      order: 890,
                      fn: (data) => {
                        return {
                          ...data,
                          styles: {
                            ...data.styles,
                            overflow: "auto",
                            maxHeight: "90vh",
                          },
                        };
                      },
                    },
                  }}
                >
                  <a
                    href="http://12u12.com/blog/"
                    target="_blank"
                    style={{ textDecoration: "none" }}
                  >
                    <p className="menu-section-separator">
                      {t("menu.SECTION_MY_DATA")}
                    </p>
                  </a>

                  <DropdownItem
                    onClick={this.gotoPath.bind(this, "/symptom")}
                  >
                    <span className="nav-link">{t("menu.INPUT")}</span>
                  </DropdownItem>
                  <DropdownItem
                    onClick={this.gotoPath.bind(this, "/editsymptoms")}
                  >
                    <span className="nav-link">{t("menu.EDIT")}</span>
                  </DropdownItem>
                  <DropdownItem onClick={this.gotoPath.bind(this, "/graph")}>
                    <span className="nav-link">{t("menu.ANALYZE")}</span>
                  </DropdownItem>
                  <DropdownItem
                    onClick={this.gotoPath.bind(this, "/dashboard")}
                  >
                    <span className="nav-link">{t("menu.VIEW_SUMMARY")}</span>
                  </DropdownItem>

                  <DropdownItem
                    onClick={this.gotoPath.bind(this, "/dailyinputsummary")}
                  >
                    <span className="nav-link">
                      {t("menu.DAILY_INPUT_SUMMARY")}
                    </span>
                  </DropdownItem>

                  {/* My Recipes */}
                  <p className="menu-section-separator">
                    <a
                      href="http://12u12.com/blog/"
                      target="_blank"
                      style={{ textDecoration: "none", color: "gray" }}
                    >
                      {t("menu.SECTION_MY_RECIPES")}
                    </a>
                  </p>

                  <DropdownItem onClick={this.gotoPath.bind(this, "/recipe")}>
                    <span className="nav-link">{t("general.CREATE")}</span>
                  </DropdownItem>
                  <DropdownItem
                    onClick={this.gotoPath.bind(this, "/recipemanagement")}
                  >
                    <span className="nav-link">
                      {t("menu.MANAGE_AND_EDIT")}
                    </span>
                  </DropdownItem>
                  <DropdownItem onClick={this.gotoPath.bind(this, "/inbox")}>
                    <span className="nav-link">
                      {t("inbox.PAGE_TITLE")}{" "}
                      <span
                        className="notification-count"
                        style={{
                          backgroundColor:
                            this.state.notifyNum && this.state.notifyNum != 0
                              ? "red"
                              : "#495057a6",
                        }}
                      >
                        {this.state.notifyNum > 99
                          ? "99+"
                          : this.state.notifyNum}
                      </span>
                    </span>
                  </DropdownItem>
                  <p className="menu-section-separator">
                    <a
                      href="http://12u12.com/blog/"
                      target="_blank"
                      style={{ textDecoration: "none", color: "gray" }}
                    >
                      {t("menu.MEAL_PLAN_TITLE")}
                    </a>
                  </p>
                  <DropdownItem
                    onClick={this.gotoPath.bind(this, "/mealplanner")}
                  >
                    <span className="nav-link">{t("general.CREATE")}</span>
                  </DropdownItem>
                  <DropdownItem
                    onClick={this.gotoPath.bind(this, "/mealplansummary")}
                  >
                    <span className="nav-link">
                      {t("menu.MEAL_PLAN_SUMMARY")}
                    </span>
                  </DropdownItem>
                  <p className="menu-section-separator">
                    <a
                      href="http://12u12.com/blog/"
                      target="_blank"
                      style={{ textDecoration: "none", color: "gray" }}
                    >
                      {t("menu.FORUM")}
                    </a>
                  </p>
                  <DropdownItem
                    onClick={this.gotoPath.bind(this, "/forum/me")}
                  >
                    <span className="nav-link">
                      {t("menu.CREATE_POST_PAGE")}
                    </span>
                  </DropdownItem>
                  <DropdownItem onClick={this.gotoPath.bind(this, "/forum")}>
                    <span className="nav-link">{t("menu.FORUM_LINK")}</span>
                  </DropdownItem>
                  <DropdownItem
                    onClick={this.gotoPath.bind(this, "/forum/archive")}
                  >
                    <span className="nav-link">
                      {t("forum.ARCHIVE_TITLE")}
                    </span>
                  </DropdownItem>

                  {/* tools & settings */}
                  <p className="menu-section-separator">
                    <a
                      href="http://12u12.com/blog/"
                      target="_blank"
                      style={{ textDecoration: "none", color: "gray" }}
                    >
                      {t("menu.SECTION_TOOLS_SETTING")}
                    </a>
                  </p>
                  <DropdownItem
                    onClick={this.gotoPath.bind(this, "/profile")}
                  >
                    <span className="nav-link">
                      {t("general.PROFILE_TITLE")}
                    </span>
                  </DropdownItem>

                  <DropdownItem
                    onClick={this.gotoPath.bind(this, "/contribute")}
                  >
                    <span className="nav-link">
                      {t("menu.CONTRIBUTE_DATA")}
                    </span>
                  </DropdownItem>

                  <DropdownItem
                    onClick={this.gotoPath.bind(this, "/infoandsupport")}
                  >
                    <span className="nav-link">
                      {t("menu.INFO_AND_SUPORT")}
                    </span>
                  </DropdownItem>

                  <DropdownItem
                    onClick={this.gotoPath.bind(this, "/message")}
                  >
                    <span className="nav-link">
                      {t("menu.INBOX")}{" "}
                      <span
                        className="notification-count"
                        style={{
                          backgroundColor:
                            this.state.inboxNum && this.state.inboxNum != "0"
                              ? "red"
                              : "#495057a6",
                        }}
                      >
                        {this.state.inboxNum > 99
                          ? "99+"
                          : this.state.inboxNum}
                      </span>
                    </span>
                  </DropdownItem>
                  <DropdownItem onClick={this.doLogout}>
                    <span className="nav-link">{t("menu.LOGOUT")}</span>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            )
          }
        </Navbar>
        <Switch>
          <Route
            exact
            path="/forgotpasswordreset/:user/:key/:lang"
            component={ForgotPasswordReset}
          />
          <Route path="/forgotpassword" component={ForgotPassword} />
          <Route path="/resetpassword" component={ResetPassword} />
          <Route path="/signup" component={SignUp} />
          <Route path="/dashboard" component={MainView} />
          <Route path="/profile/update/:id" component={ProfileUpdate} />
          <Route path="/profile" component={Profile} />
          <Route path="/changepassword" component={ChangePassword} />
          <Route path="/subusercreate" component={SubUserCreate} />
          <Route path="/recipemanagement" component={RecipeManagement} />
          <Route path="/recipe" component={isLoggedIn() ? Recipe : HomePage} />
          <Route path="/mealplansummary/:date?" component={MealPlanSummary} />
          <Route path="/mealplanner/:date?" component={MealPlanner} />
          <Route path="/forum/me" component={ForumMe} />
          <Route path="/forum/archive/:id?/:lang?" component={ForumArchive} />
          <Route path="/forum/post/:postId" component={ForumSingle} />
          <Route path="/forum/:userId" component={ForumMe} />
          <Route path="/forum/" component={Forum} />
          <Route path="/main" component={Dashboard} />
          <Route path="/symptom" component={Symptom} />
          <Route path="/graph" component={Graph} />
          <Route path="/dailyinputsummary" component={DailyInputSummary} />
          <Route path="/infoandsupport" component={InfoAndSupport} />
          <Route path="/editsymptoms" component={EditSymptom} />
          <Route path="/contribute" component={Contribute} />
          <Route path="/contributeCom" component={Contribute} />
          <Route path="/bodymap" component={BodyMap} />
          <Route path="/inbox" component={Inbox} />
          <Route path="/message" component={MessagingInbox} />
          <Route path="/" component={HomePage} />
        </Switch>
      </Container>
    );
  }
}

MainPage = translate("translations")(MainPage);

export default MainPage;



// WEBPACK FOOTER //
// ./src/pages/MainPage.js